import React, { FC, useMemo } from "react";
import { useFormState } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { IWizardStepContent } from "../../../../wizard/types";
import {
  AgeRange,
  AssignBranches,
  Category,
  CourseTypeInput,
  Language,
} from "../../components";
import Grid from "@material-ui/core/Grid/Grid";

const Content: FC<IWizardStepContent> = ({ stepName }) => {
  const { submitFailed, dirtySinceLastSubmit, invalid, submitErrors } =
    useFormState();

  const hasError = useMemo(
    () => invalid && submitFailed && !dirtySinceLastSubmit,
    [invalid, dirtySinceLastSubmit, submitFailed],
  );
  const errors = useMemo(
    () => (hasError && submitErrors?.[stepName] ? submitErrors[stepName] : {}),
    [hasError, submitErrors],
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Language
            label="Language"
            fieldName={`${stepName}.language`}
            errors={errors?.language}
          />
        </Grid>
      </Grid>
      <Category fieldsGroupName={stepName} errors={errors} />
      <CourseTypeInput fieldsGroupName={stepName} errors={errors} />
      <AgeRange fieldsGroupName={stepName} />
      <FieldArray
        fieldsGroupName={stepName}
        errors={errors}
        name={`${stepName}.branches`}
        component={AssignBranches}
      />
    </>
  );
};

export default Content;
